import React from "react";
import { alpha, Box, Paper, Typography } from "@mui/material";

interface ErrorCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  detail?: string | null;
  children?: React.ReactNode;
}

export default function ErrorCard({
  icon,
  title,
  description,
  detail,
  children,
}: ErrorCardProps): React.ReactNode {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: "inherit",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 4, md: 6 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
          maxWidth: 480,
          width: "100%",
          bgcolor: "var(--color-surface)",
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            bgcolor: (theme) => alpha(theme.palette.error.main, 0.1),
            color: "error.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          {icon}
        </Box>

        <Typography variant="h5" component="h1" gutterBottom fontWeight="600">
          {title}
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: 1.6 }}
          >
            {description}
          </Typography>
          {detail && (
            <Typography
              variant="body2"
              component="i"
              color="text.secondary"
              sx={{ display: "block", mt: 1 }}
            >
              {detail}
            </Typography>
          )}
        </Box>

        {children}
      </Paper>
    </Box>
  );
}
